import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { withRealTimeBiddingData } from 'Context/BiddingContext';
import { VehicleContextProvider } from 'Context/VehicleContext';
import proPropTypes from 'Utilities/proPropTypes';

const VehicleCardContextAndRTBWrapper = (props) => {
	const { children, subscribeVehicleToRealTimeBidding, vehicle } = props;
	const {
		id,
		state: { slug },
	} = vehicle;

	useEffect(() => {
		subscribeVehicleToRealTimeBidding({ id, stateSlug: slug });
	}, [id, slug, subscribeVehicleToRealTimeBidding]);

	return <VehicleContextProvider vehicle={vehicle}>{children}</VehicleContextProvider>;
};

VehicleCardContextAndRTBWrapper.displayName = 'VehicleCardContextAndRTBWrapper';

VehicleCardContextAndRTBWrapper.defaultProps = {
	subscribeVehicleToRealTimeBidding: () => null,
	vehicle: {},
};

VehicleCardContextAndRTBWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	subscribeVehicleToRealTimeBidding: PropTypes.func,
	vehicle: proPropTypes.vehicleCardList,
};

const VehicleCardContextAndRTBWrapperMemo = React.memo(VehicleCardContextAndRTBWrapper, (prevProps, nextProps) => {
	// ShouldComponentUpdate
	// https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-shouldcomponentupdate
	// Since the context provider destructures the props being sent, the shallow compare will never work as
	// `prevProps === nextProps` = false
	// So we need to compare the data, so this has reduced renders from ~2.5k to 1 each
	const prevVehicle = JSON.stringify(prevProps.vehicle);
	const nextVehicle = JSON.stringify(nextProps.vehicle);
	return prevVehicle === nextVehicle;
});

VehicleCardContextAndRTBWrapperMemo.displayName = 'VehicleCardContextAndRTBWrapperMemo';

export default withRealTimeBiddingData(VehicleCardContextAndRTBWrapperMemo);
